import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react'

const ToastContext = createContext<(message: string) => void>(() => {})

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const show = useCallback((m: string) => {
    clearTimeout(timer.current)
    setMessage(m)
    timer.current = setTimeout(() => setMessage(null), 2800)
  }, [])

  return (
    <ToastContext.Provider value={show}>
      {children}
      {/* --wr-toast-lift clears a fixed bottom bar (the reader's Take With You bar sets it). */}
      <div
        aria-live="polite"
        style={{ bottom: 'calc(var(--wr-toast-lift, 0px) + 24px)' }}
        className="pointer-events-none fixed inset-x-0 z-50 flex justify-center px-4"
      >
        {message && (
          <div className="rounded-full bg-foreground px-4 py-2.5 text-[13px] font-medium text-card shadow-[var(--shadow-chip)]">
            {message}
          </div>
        )}
      </div>
    </ToastContext.Provider>
  )
}

export function useToast(): (message: string) => void {
  return useContext(ToastContext)
}
